import firebase from "firebase/app";

export default async function algoliaIndexSearch({ index, query, filters, attributes }) {
	const { data } = await firebase.functions().httpsCallable("algolia-indexSearch")({
		index,
		query,
		filters,
		attributes,
	});

	return data;
}
